import { render, staticRenderFns } from "./MonitorsTable.vue?vue&type=template&id=7260fbf4&scoped=true&"
import script from "./MonitorsTable.vue?vue&type=script&lang=ts&"
export * from "./MonitorsTable.vue?vue&type=script&lang=ts&"
import style0 from "./MonitorsTable.vue?vue&type=style&index=0&id=7260fbf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7260fbf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
